import api from "app/api";

export interface BookingCommissionItem {
  booking_id: number;
  booking_number: string;
  date: string;
  program_name: string;
  variant_name: string;
  headcount: number;
  booking_amount: number;
  commission_rate: number;
  commission_amount: number;
}

export interface DayCommissionItem {
  date: string;
  booking_count: number;
  total_headcount: number;
  total_booking_amount: number;
  total_commission_amount: number;
}

export interface CommissionReportResponse {
  items: BookingCommissionItem[] | DayCommissionItem[];
  total_commission: number;
  group_by: "booking" | "day";
}

export async function getCommissionReport(
  partnerId: number,
  from: string,
  to: string,
  groupBy: "booking" | "day",
  currency?: "HUF" | "EUR" | null
) {
  return api.get<CommissionReportResponse>(
    `partners/${partnerId}/commission-report`,
    {
      params: { from, to, group_by: groupBy, currency },
    }
  );
}
